module.exports = __webpack_public_path__ + "img/logo.290bd991.png";